import { MapPin, Mail, Instagram, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t py-16 px-6 md:px-12" style={{ borderColor: "#1F1F23", background: "#000" }}>
      <div className="bb-container grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img src="/assets/beer-battle-logo.png" alt="Beer Battle" className="h-12 w-auto" />
            <div className="bb-display text-3xl tracking-widest" style={{ color: "var(--bb-primary)" }}>
              BEER<span style={{ color: "#fff" }}>BATTLE</span>
            </div>
          </div>
          <p className="text-zinc-500 text-sm mt-3 leading-relaxed">
            La sfida annuale di birra fatta in casa.
            <br />
            Organizzato da Valentino e Marco.
          </p>
        </div>
        <div>
          <h4 className="bb-eyebrow">Location</h4>
          <a
            href="https://maps.app.goo.gl/E8d2qStsRke3sSpJ6"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-location"
            className="mt-4 text-zinc-300 hover:text-[var(--bb-primary)] flex items-start gap-2 text-sm transition-colors group"
          >
            <MapPin size={16} style={{ color: "var(--bb-primary)" }} className="mt-0.5 flex-shrink-0" />
            <span>
              Hilltop Brewery
              <br />
              Bassano Romano, RM
              <br />
              <span className="text-xs text-zinc-500 group-hover:text-[var(--bb-primary)]">
                → Apri in Google Maps
              </span>
            </span>
          </a>
        </div>
        <div>
          <h4 className="bb-eyebrow">Contatti</h4>
          <div className="mt-4 space-y-2 text-sm">
            <a
              href="mailto:beerbattle2718@gmail.com"
              data-testid="footer-email"
              className="text-zinc-300 hover:text-[var(--bb-primary)] flex items-center gap-2"
            >
              <Mail size={16} /> beerbattle2718@gmail.com
            </a>
            <a
              href="https://www.instagram.com/beer__battle/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="text-zinc-300 hover:text-[var(--bb-primary)] flex items-center gap-2"
            >
              <Instagram size={16} /> @beer__battle
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=100063828330774&locale=it_IT"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-facebook"
              className="text-zinc-300 hover:text-[var(--bb-primary)] flex items-center gap-2"
            >
              <Facebook size={16} /> Beer Battle
            </a>
          </div>
        </div>
      </div>
      <div className="bb-container mt-12 pt-6 border-t border-zinc-900 text-xs text-zinc-600 flex flex-wrap justify-between gap-2">
        <span>© {new Date().getFullYear()} Beer Battle — Hilltop Brewery, Bassano Romano</span>
        <a href="/admin" className="hover:text-[var(--bb-primary)]" data-testid="admin-link">Admin</a>
      </div>
    </footer>
  );
}
